import { AccountView } from "../view/account/account.view";
import { InstitutionView } from "../view/institution/institution.view";
import { CountryView } from "../view/country/country.view";
import { CategoryView } from "@bitwarden/web-vault/app/models/view/category/category.view";
import { ModelView } from "@bitwarden/web-vault/app/models/view/model.view";
import { ExternalView } from "@bitwarden/web-vault/app/models/view/external.view";
import { StoreModel } from "@bitwarden/web-vault/app/services/dali/vault-parser/parser.type";

export abstract class BaseFilter<T extends ModelView<StoreModel> | ExternalView> {
  view: T;
  childFilter?: Map<string, BaseFilter<ModelView | ExternalView>>;
  isSelected: boolean;
  isDisabled: boolean;
}

export class CategoryFilter extends BaseFilter<CategoryView> {
  view: CategoryView;
  isSelected: boolean;
  isDisabled: boolean;
}

export class CountryFilter extends BaseFilter<CountryView> {
  view: CountryView;
  childFilter: Map<string, InstitutionFilter>;
  isSelected: boolean;
  isDisabled: boolean;
}

export class AccountFilter extends BaseFilter<AccountView> {
  view: AccountView;
  isSelected: boolean;
  isDisabled: boolean;
}

export class InstitutionFilter extends BaseFilter<InstitutionView> {
  view: InstitutionView;
  childFilter: Map<string, AccountFilter>;
  isSelected: boolean;
  isDisabled: boolean;
}

export type MainFilter<T extends AllowedMainFilterType> = {
  [Key in keyof T as `${string & Key}Filter`]: T[Key];
};

export type AllowedMainFilterType = PastMainFilterType | CountryMainFilterType;

export type PastMainFilterType = {
  country: Map<string, CountryFilter>;
  category: Map<string, CategoryFilter>;
};

export type CountryMainFilterType = {
  country: Map<string, CountryFilter>;
};

/** @Note **_isDefault** is managed by the store **/
export type PeriodType = {
  startDate: Date;
  endDate: Date;
  _isDefault: boolean;
};

export interface ScenarioFilterControlType {
  countries: string[];
  accounts: string[];
  blockedAccounts: string[];
  institutions: string[];
  symbols: string[];
}
